import * as RetentionPages from './pages'

export const retentionReducer = (state, action, data) => {
  switch (action.type) {
    case 'continueButton': {
      if (state.activePage === RetentionPages.FEEDBACK) {
        return { activePage: RetentionPages.DETAILS }
      }
      break
    }
    case 'previousButton': {
      if (state.activePage === RetentionPages.DETAILS) {
        return { activePage: RetentionPages.FEEDBACK }
      }
      if (state.activePage === RetentionPages.REVIEW) {
        return { activePage: RetentionPages.DETAILS }
      }
      break
    }
    case 'noThanksButton': {
      return { activePage: RetentionPages.REVIEW }
    }
    case 'suspendButton': {
      return {
        action: 'suspension',
        activePage: RetentionPages.ACTION_COMPLETE
      }
    }
    case 'cancelButton': {
      return {
        action: 'cancellation',
        activePage: RetentionPages.ACTION_COMPLETE
      }
    }
    case 'discountButton': {
      return {
        action: 'discount',
        activePage: RetentionPages.ACTION_COMPLETE
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}
